import { useEffect, useState } from 'react';

/** Monte le footer SEO mobile une fois le main stabilisé (évite CLS quand le lazy below-the-fold pousse le footer). */
export function useDeferredSeoFooterMount(enabled: boolean, pathname: string): boolean {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setMounted(false);
      return;
    }

    let cancelled = false;
    let stableTimer: ReturnType<typeof setTimeout> | undefined;
    let lastHeight = -1;

    const scheduleStable = () => {
      if (stableTimer) clearTimeout(stableTimer);
      stableTimer = setTimeout(() => {
        if (!cancelled) setMounted(true);
      }, 900);
    };

    const onResize = () => {
      const main = document.querySelector<HTMLElement>('.app-shell__content');
      if (!main) return;
      const h = main.offsetHeight;
      if (h === lastHeight) {
        scheduleStable();
        return;
      }
      lastHeight = h;
      if (stableTimer) clearTimeout(stableTimer);
      stableTimer = setTimeout(onResize, 350);
    };

    setMounted(false);
    lastHeight = -1;
    onResize();

    const main = document.querySelector<HTMLElement>('.app-shell__content');
    const ro =
      main && typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => onResize())
        : null;
    ro?.observe(main!);

    const maxTimer = setTimeout(() => {
      if (!cancelled) setMounted(true);
    }, 9000);

    return () => {
      cancelled = true;
      if (stableTimer) clearTimeout(stableTimer);
      clearTimeout(maxTimer);
      ro?.disconnect();
    };
  }, [enabled, pathname]);

  return mounted;
}
